module.exports = __webpack_public_path__ + "static/img/R290.31a09c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R290.jpg
// module id = qa2y
// module chunks = 1